<template>
  <el-form ref="form" :model="form" :rules="rules" label-width="80px" label-position="left">
    <el-form-item label="定价模式" prop="pricingModel">
      <el-radio-group v-model="form.pricingModel" :disabled="id">
        <el-radio label="1">指定金额</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-row>
      <el-col span="1"></el-col>
      <el-col span="23">
        <el-form-item label="算费费率" prop="feePrice" style="display：flex;">
          <el-row gutter="10">
            <el-col span="6">
              <el-input type="text" v-model="form.feePrice" style="width: 100%" :disabled="id" maxlength="10" :show-word-limit="true"></el-input>
            </el-col>
            <el-col span="2">
              <!-- 元 / m
              <sup>2</sup> -->
              元
            </el-col>
            <el-col span="3">
              <el-select v-model="form.feeUnit" placeholder="请选择" style="width: 100%" :disabled="id">
                <template v-for="item in dicts.fee_standard_unit">
                  <el-option
                    v-if="item.dictKey[0] == fee_standard_unit_first_number"
                    :key="item.dictKey"
                    :label="item.dictValue"
                    :value="item.dictKey"
                  ></el-option>
                </template>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label="不足月计算方式" label-width="120px" prop="lessMonthWay">
          <el-row gutter="10">
            <el-col span="6">
              <el-select v-model="form.lessMonthWay" placeholder="请选择" style="width: 100%" :disabled="id">
                <el-option
                  v-for="(item, index) in dicts.fee_standard_less_month_way"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-col>
            <el-col span="6">
              <el-select v-model="form.lessMonthDaysWay" placeholder="请选择" style="width: 100%" :disabled="id">
                <el-option
                  v-for="(item, index) in dicts.fee_standard_less_month_days_way"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  props: {
    form: Object,
    dicts: Object,
    id:String
  },
  data() {
    return {
      fee_standard_unit_first_number: '2',
      rules:{
        feePrice: [
          { required: true, message: '请输入费率', trigger: 'change' },
          { validator:(rule,value,cb)=>{
            value = value + '';
            console.log('value==>',value);
            if(!/^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/.test(value)){
              cb(new Error('金额格式错误'))
            }else{
              cb()
            }
          }, message: '格式错误', trigger: 'change' },
        ],
        pricingModel:[{ required: true, message: '请选择', trigger: 'change' }],
        lessMonthWay: [{ required: true, message: '请选择', trigger: 'change' }],
      }
    };
  },
  methods: {
    validate() {
      return new Promise((resolve, rej) => {
        this.$refs.form
          .validate()
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            rej(err);
          });
      });
    },
    setInitValue() {
      if (this.dicts) {
        //不足月计算方式
        this.form.lessMonthDaysWay =
          this.dicts.fee_standard_less_month_days_way &&
          this.dicts.fee_standard_less_month_days_way[0].dictKey;
        this.form.lessMonthWay =
          this.dicts.fee_standard_less_month_way &&
          this.dicts.fee_standard_less_month_way[0].dictKey;
        //算费费率单位
        if (this.dicts.fee_standard_unit) {
          for (let i = 0; i < this.dicts.fee_standard_unit.length; i++) {
            let item = this.dicts.fee_standard_unit[i];
            if (item.dictKey[0] == this.fee_standard_unit_first_number) {
              this.form.feeUnit = item.dictKey;
              break;
            }
          }
        }
      }
    },
  },
  created() {
    this.setInitValue();
  },
};
</script>